<div class="card follower-wrap">
  <div class="card-header card-no-border">
    <h5 class="mb-1">{{ 'Facebook Campaign' | translate }}</h5>
    <div class="d-inline-block badge badge-light-success rounded-pill">{{ 'Active' | translate }}</div>
  </div>
  <div class="card-body pt-0 papernote-wrap">
    <ul class="campaign-list">
      <li>
        <div class="campaign-box">
          <h5 class="mb-1">{{ '1,897' | translate }}</h5>
          <span class="f-light">{{ 'Followers today' | translate }}</span>
        </div>
      </li>
      <li>
        <div class="campaign-box">
          <h5 class="mb-1">{{ '50,000' | translate }}</h5>
          <span class="f-light">{{ 'Followers goals' | translate }}</span>
        </div>
      </li>
    </ul>
    <div class="customers">
      <ul>
        <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/1.jpg" alt="user" /></li>
        <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/6.jpg" alt="user" /></li>
        <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/7.jpg" alt="user" /></li>
        <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/3.jpg" alt="user" /></li>
        <li class="d-inline-block"><img class="img-40 rounded-circle" src="assets/images/dashboard/user/8.jpg" alt="user" /></li>
        <li class="d-inline-block">
          <div class="light-card"><span class="f-w-500">{{ '+5' | translate }}</span></div>
        </li>
      </ul>
    </div>
  </div>
</div>
